var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "job--edit--languages" }, [
    _c(
      "div",
      { staticClass: "job--edit--languages-items" },
      _vm._l(_vm.languages, function(language) {
        return _c("LanguageItem", {
          key: language.id,
          attrs: { language: language, "used-languages": _vm.usedLanguages },
          on: {
            remove: function($event) {
              return _vm.remove(language)
            },
            change: function($event) {
              return _vm.languageChanged(language, $event)
            }
          }
        })
      }),
      1
    ),
    _vm._v(" "),
    _vm.allValid
      ? _c(
          "div",
          { staticClass: "job--edit--languages-add-container" },
          [
            _c("IconLink", {
              attrs: { icon: "plus", text: "Sprache hinzufügen" },
              on: { click: _vm.add }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.languages.length > 0 && !_vm.motherValid
      ? _c("div", { staticClass: "error mt-4 text-right" }, [
          _vm._v("\n\t\tBitte gib jedenfalls deine Muttersprache/n an.\n\t")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }